import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/admin-tica")({
  head: () => ({
    meta: [
      { title: "Panel Tica | TiemposHoy" }, { property: "og:title", content: "Panel Tica | TiemposHoy" }, { property: "og:type", content: "website" }, { name: "twitter:card", content: "summary" },
      { name: "description", content: "Panel privado con estadísticas y pronósticos de los Tiempos de Costa Rica." },
      { property: "og:description", content: "Panel privado con estadísticas y pronósticos de los Tiempos de Costa Rica." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <ProtectedRoute>
      <main className="mx-auto max-w-xl px-4 py-12">
        <h1 className="mb-4 text-2xl font-bold">Laboratorio Tica apagado</h1>
        <p className="mb-6 text-muted-foreground">Los pronósticos y las evaluaciones están suspendidos. El historial se conserva.</p>
        <Button asChild variant="outline"><Link to="/admin-resultados">Volver a resultados</Link></Button>
      </main>
    </ProtectedRoute>
  ),
});
